import { get, post } from '../../Http/index'
import {  ASSET } from "../../config";
//查询资产类别全部
function assetType(){
    return post(`/api-finbasic/basicassetclass/queryAll`,{})
}
//查询计量单位
function unitAll(){
    return post(`/api-finbasic/basicunit/queryAll`,{})
}


//资产地点
function siteSave(params){
    return post(`/${ASSET}/assetsite/save`,params)
}
function siteList(params) {
    return post(`${ASSET}/assetsite/list`,params)
}
function siteDelete(params) {
    return post(`/api-finance-asset/assetsite/deleteSite`,params)
}
function siteAll() {
    return post(`/api-finance-asset/assetsite/findAll`,{})
}

//资产设置
function assetConfigSave(params) {
    return post(`${ASSET}/assetconfig/save`,params)
}
function assetConfigQuery(params) {
    return post(`${ASSET}/assetconfig/list`,params)
}

//资产类别
function assetClassSave(params) {
    return post(`/api-finance-asset/assetclassinfo/save`,params)
}
function assetClassList(params) {
    return post(`/api-finance-asset/assetclassinfo/list`,params)
}

function assetClassDelete(params) {
    return post(`/api-finance-asset/assetclassinfo/deleteClass`,params)
}

function assetClassAll(params) {
    return post(`/api-finance-asset/assetclassinfo/findList`,params)
}



export default {
    siteSave,
    siteList,
    siteDelete,
    assetConfigSave,
    assetConfigQuery,
    assetType,
    unitAll,
    assetClassSave,
    assetClassList,
    assetClassDelete,
    siteAll,
    assetClassAll
    

}



// WEBPACK FOOTER //
// ./src/api/assest-management/base-management/index.js